export const paginationTokens = {
  'pagination-btn-size': '32px',
  'pagination-btn-border-radius': 'var(--dp-border-radius-md)',
  'pagination-btn-font-size': 'var(--dp-font-size-sm)',
  'pagination-active-bg': 'var(--dp-color-primary)',
  'pagination-active-text': 'var(--dp-color-text-inverse)',
  'pagination-hover-bg': 'var(--dp-color-surface-hover)',
  'pagination-gap': 'var(--dp-spacing-xs)',
  'pagination-disabled-opacity': '0.5',
} as const;
